import { makeStyles } from '@mui/styles';

// One scroll owner: the document. No overflow on the page or Paper; the desktop
// table scrolls horizontally only inside its own TableContainer.
// Desktop (>= sm) keeps the previous 15px gap and 30px/20px Paper padding.
export const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
    gap: theme.spacing(1.875),
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(1.5),
      padding: theme.spacing(2)
    }
  },
  item: { minWidth: 0 },
  paperContainer: {
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
    padding: theme.spacing(3.75, 2.5),
    [theme.breakpoints.down('sm')]: { padding: theme.spacing(2, 1.5) }
  },
}));
